News
<template>
    <div class="news-wrap">
        <p class="new-mess">相关报导 ／ Media Coverage</p>
        <div class="news-con">
            <!-- <p class="media-news">媒体报道</p> -->
            <ul>
                <p>官方讯息</p> 
                <li class="news-item" v-for="item in newsTwo" :key="item.href">
                    <img v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/img/${item.img}`" alt="" />
                    <a target="_blank" :href="item.href">{{ item.mess }}</a>
                </li>
            </ul>
            <ul>
                <p>媒体报道</p> 
                <li class="news-item" v-for="item in newsOne" :key="item.href">
                    <img v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/img/${item.img}`" alt="" />
                    <a target="_blank" :href="item.href">{{ item.mess }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style>
.news-wrap {
    position: absolute;
    width: 60%;
    height: 95%;
    left: 5%;
    top: 0;
}
.new-mess {
    color: #fff;
    font-size: 17px;
    margin: 30px 0px;
    text-align: left;
}
.news-con {
    height: 80%;
    border-radius: 4px;
    /* overflow-y: scroll; */
}
.news-con ul {
    overflow-y: auto;
    height: 100%;
    width: 43%;
    float: left;
    margin-right: 45px;
    background: #fff;
    border-radius: 10px;
}
.news-con ul p{
    font-size: 15px;
    margin: 15px 25px;
    text-align: left;
}
.news-item {
    width: 100%;
    height: 11.5%;
    overflow: hidden;
    margin-top: 8px;
}
.news-item img {
    width: 50px;
    height: auto;
    border-radius: 100%;
}
.news-item img,
.news-item a {
    display: inline-block;
    vertical-align: middle;
}
.news-item a {
    width: 70%;
    text-overflow: ellipsis;
    line-height: 20px;
    padding-left: 10px;
    overflow: hidden;
    font-size: 12px;
    text-align: left;
}
</style>
<script>
export default {
    data() {
        return {
            newsOne: [
                {
                    img: 'logo-wwp.png',
                    href: 'http://paper.wenweipo.com/2020/08/29/OT2008290006.html',
                    mess: '“限量藝術書《AMICITIA》在滬發布 荷蘭藝術家以紅酒敬友誼”',
                },
                {
                    img: 'xinmin300.png',
                    href: 'https://wap.xinmin.cn/newspaper/shequ/1954.html',
                    mess: '“限量艺术书《AM ICITIA》在上海隆重发布',
                },
                {
                    img: 'thumbnailzhi44.png',
                    href: 'http://www.sh.chinanews.com/wenhua/2020-07-26/79036.shtml',
                    mess: '荷兰艺术家Peter Riezebos限量艺术书《AMICITIA》全球发布亮相上海',
                },
                {
                    img: '20165271464326078227_259_b.png',
                    href: 'https://mparticle.uc.cn/video.html?uc_param_str=frdnsnpfvecpntnwprdssskt&wm_aid=fb30692884a847e8a9d0d760a355812c',
                    mess: '《AMICITIA》全球发布之上海发布会召开 荷兰艺术家Peter Riezebos线上参与互动',
                },
                {
                    img: '170522192886a67b03b30a47507b94f39e059ff3d0.jpeg',
                    href: 'https://video.tudou.com/v/XNDc2OTY0ODI5Mg==.html?spm=a2h0k.8191414.0.0&amp;from=s1.8-1-1.2',
                    mess: '《AMICITIA》全球发布之上海发布会召开 荷兰艺术家Peter Riezebos线上参与互动',
                },
                {
                    img: 'TB1XRG1koT1gK0jSZFrXXcNCXXa-180-36.png',
                    href: 'https://v.youku.com/v_show/id_XNDc3NjU5NDY3Mg==.html',
                    mess: '《AMICITIA》全球发布之上海发布会召开'

                },
                {
                    img: 'TB1XRG1koT1gK0jSZFrXXcNCXXa-180-36.png',
                    href:'https://v.youku.com/v_show/id_XNDc2OTY0ODI5Mg==.html?spm=a2hbt.13141534.app.5~5!2~5!2~5~5~5!2~5~5!2~5!2~5!2~5~5!27~A',
                    mess: '《AMICITIA》全球发布之上海发布会召开 荷兰艺术家Peter Riezebos线上参与互动',
                },
                {
                    img: 'share.png',
                    href: 'http://news.i-shanghai.sh.cn/news/2020/07/27/20200727IdLJBAUbTEkGKOBl.shtml',
                    mess: '《AMICITIA》全球发布 | 荷兰艺术家Peter Riezebos以红酒敬友谊',
                },
                {
                    img: 'onlinegzh.jpeg',
                    href: 'https://joy.online.sh.cn/content/2020-07/27/content_9610715.htm',
                    mess: '荷兰艺术家限量艺术书《AMICITIA》在沪发布',
                },
                {
                    img: 'c227ee612a8546b285f8fa1433cc20df_1489741049063.jpeg',
                    href: 'https://www.sohu.com/a/409543369_571581',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'i1562744530_1.jpeg',
                    href: 'https://v.qq.com/x/page/o3121nf49v9.html',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'sinalogo-nav.jpeg',
                    href: 'http://sh.sina.com.cn/life/other/2020-07-25/detail-iivhuipn5012680.shtml',
                    mess: '荷兰艺术家艺术书《AMICITIA》在沪发布 8000张影像致敬友谊',
                },
                {
                    img: 'sinalogo-nav.jpeg',
                    href: 'https://sh.sina.cn/life/other/2020-07-25/detail-iivhuipn5012680.d.html?sinawapsharesource=newsapp&wm=3200_0001',
                    mess: '荷兰艺术家艺术书《AMICITIA》在沪发布 8000张影像致敬友谊',
                },
                {
                    img: 'logo.c9399c5e.png',
                    href: 'http://share.v1.cn/share-video?id=1286919799551479810',
                    mess: '《AMICITIA》全球发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'mangguo.jpg',
                    href: 'https://www.mgtv.com/b/334916/9466101.html?lastp=v_progdtl',
                    mess: '限量艺术书《AMICITIA》上海发布会召开',
                },
                {
                    img: 'mangguo.jpg',
                    href: 'https://www.mgtv.com/b/334916/9466101.html?fpa=se&lastp=so_result',
                    mess: '限量艺术书《AMICITIA》上海发布会召开',
                },
                {
                    img: 'TB1XRG1koT1gK0jSZFrXXcNCXXa-180-36.png',
                    href: 'https://v.youku.com/v_show/id_XNDc2ODMxMTQzNg==.html',
                    mess: '《AMICITIA》探索观念及行为艺术 彼得·莱兹伯斯倾情创作致敬友谊',
                },
                {
                    img: 'TB1XRG1koT1gK0jSZFrXXcNCXXa-180-36.png',
                    href: 'https://v.youku.com/v_show/id_XNDc2NjUwNDM1Ng==.html',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'logo_Finance.png',
                    href: 'https://n.021east.com/pnews/1595644488021314',
                    mess: '历时近4年，50万公里飞行 荷兰艺术家艺术书《AMICITIA》在沪发布',
                },
                {
                    img: 'logo3.png',
                    href: 'http://wenhui.whb.cn/zhuzhanapp/hsttupian/20200726/362894.html?from=singlemessage',
                    mess: '历时近4年、50万公里飞行，荷兰艺术家与上海的不解情缘凝聚在这本画册',
                },
                {
                    img: 'c227ee612a8546b285f8fa1433cc20df_1489741049063.jpeg',
                    href: 'http://ffyl.cnlive.com/yule/detail2_2020_07/24/2160331.html',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'timg.jpeg',
                    href: 'http://video.tudou.com/v/XNDc2ODMxMTQzNg==.html',
                    mess: '限量艺术书《AMICITIA》上海发布会召开',
                },
                {
                    img: 'u=380991828,2500863034&fm=26&gp=0.jpg',
                    href: 'https://www.bilibili.com/video/BV1Wv411q7Hi/',
                    mess: '《AMICITIA》探索观念及行为艺术 彼得·莱兹伯斯倾情创作致敬友谊',
                },
                {
                    img: 'timg(1).jpeg',
                    href: 'https://www.iqiyi.com/v_19rz4l5m28.html',
                    mess: '《AMICITIA》探索观念及行为艺术 彼得·莱兹伯斯倾情创作致敬友谊',
                },
                {
                    img: 'timg(2).jpeg',
                    href: 'https://mparticle.uc.cn/video.html?uc_param_str=frdnsnpfvecpntnwprdssskt&wm_id=80d3ca569c404c788dc1cdb6973bd7de&wm_aid=92390649a58c4b52933addc008849815',
                    mess: '《AMICITIA》探索观念及行为艺术 彼得·莱兹伯斯倾情创作致敬友谊',
                },
                {
                    img: 'timg(3).jpeg',
                    href: 'https://www.ixigua.com/6853028217809273348/',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'baijia.png',
                    href: 'https://haokan.baidu.com/v?pd=bjh&vid=11023592115187843541&fr=bjhauthor&type=video',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'qie.jpg',
                    href: 'https://page.om.qq.com/page/OBlFh9-hL1LrWJUxr7Ac264g0',
                    mess: '限量艺术书《AMICITIA》在上海隆重发布 荷兰艺术家以红酒敬友谊',
                },
                {
                    img: 'timg(4).jpeg',
                    href: 'http://www.miguvideo.com/mgs/website/prd/detail.html?cid=682819772',
                    mess: '限量艺术书《AMICITIA》发布 荷兰艺术家以红酒敬友谊',
                },

            ],
            newsTwo: [
                 {
                    img: 'artgogo.png',
                    href: 'https://mp.weixin.qq.com/s/uqhNeMzIrsvFP9Y6W4G09A',
                    mess: '7月23日傍晚17:00，我们将带你提前走进艺术家Peter Riezebos的艺术项目，一个把友谊放到最大',
                },
                 {
                    img: 'artgogo.png',
                    href: 'https://mp.weixin.qq.com/s/bpMiBUjV0a3CKd8SWUkd3Q',
                    mess: '对于你来说，友谊是什么？7月24日，15:00，艺术家PETER RIEZEBOS的答案揭晓',
                },
                 {
                    img: 'artgogo.png',
                    href: 'https://mp.weixin.qq.com/s/2-30q6k_dFH_FjonxyzU4A',
                    mess: '一生情，一杯酒，一本画册，一场艺术。以美酒敬友谊，艺术家Peter Riezebos《AMICITIA》全球发布',
                },
                {
                    img: 'artgogo.png',
                    href: 'https://mp.weixin.qq.com/s/M7hPUr1bzHi5chJ3i6sDkA',
                    mess: '倘若没有友谊，生活会是什么模样？',
                },
                 {
                    img: 'logo_48_17d0570.png',
                    href: 'https://www.yizhibo.com/l/xHb4ZbMSF6S3Dsh1.html',
                    mess: '杯酒敬友谊 PeterRiezebos的艺术项目',
                },
                 {
                    img: 'logo_48_17d0570.png',
                    href: 'https://www.yizhibo.com/l/fXXaeGsc-Ah_3sVI.html',
                    mess: 'Peter Riezebos 艺术画册《AMICITIA》全球发布',
                },
                {
                    img: 'logo_48_17d0570.png',
                    href: 'https://www.yizhibo.com/l/YFxbuKGdvYp6xutT.html',
                    mess: '夏夜艺术研讨会 第一期',
                },
                 {
                    img: 'logo_48_17d0570.png',
                    href: 'https://www.yizhibo.com/l/-KS4y8B4js8KNNv2.html',
                    mess: '艺术先说+开始艺术教室',
                },
                 {
                    img: 'logo_48_17d0570.png',
                    href: 'https://www.yizhibo.com/l/E_YxiMOs_jAWZjN0.html',
                    mess: '艺术先说 艺术日常+探宝',
                },
            ],
        };
    },
};
</script>



